// D5 horizontal trimming

export function calculateD5(totalWidths, COM) {
      console.log('calculateD5() start');

      if (COM == true) {
            switch (totalWidths) {
                  case 1:
                        return 69;
                  case 2:
                      return 138;
                  case 3:
                      return 207;
                  case 4:
                      return 276;
                  case 5:
                      return 345;
                  case 6:
                      return 414;
                  case 7:
                      return 483;
                  case 8:
                      return 552;
                  case 9:
                      return 621;
                  case 10:
                      return 690;
                  default:
                        console.log('- totalWidths out of scope');
                        return 0;
            }            
      } else if (COM == false) {
            switch (totalWidths) {
                  case 1:
                        return 60;
                  case 2:
                        return 120;
                  case 3:
                       return 180;
                  case 4:
                       return 240;
                  case 5:
                        return 300;
                  case 6:
                       return 360;
                  case 7:
                        return 420;
                  case 8:
                       return 480;
                  case 9:
                        return 540;
                  case 10:
                        return 600;
                  default:
                        console.log('- totalWidths out of scope');
                        return 0;
            }
      } else {
            console.log('- COM is null');
      }
}
